import React from "react";
import { PricingStrategy } from "../../../../types";

interface WeekendStrategyBannerProps {
  strategy: PricingStrategy;
  onApply: () => void;
  onDismiss: () => void;
}

const WeekendStrategyBanner: React.FC<WeekendStrategyBannerProps> = ({
  strategy,
  onApply,
  onDismiss,
}) => {
  console.log("🏨 WeekendStrategyBanner received strategy:", {
    strategy,
    hasPricingSuggestion: !!strategy.pricingSuggestion,
    pricingSuggestion: strategy.pricingSuggestion,
    coefficient: strategy.coefficient,
    type: strategy.type,
  });

  const discountPercentage = strategy.pricingSuggestion?.discountPercent
    ? Math.round(strategy.pricingSuggestion.discountPercent)
    : Math.round((1 - strategy.coefficient) * 100);

  console.log("🏨 WeekendStrategyBanner calculated:", {
    discountPercentage,
    usedPricingSuggestion: !!strategy.pricingSuggestion?.discountPercent,
    fallbackCalculation: Math.round((1 - strategy.coefficient) * 100),
  });

  const isDiscount = discountPercentage < 0;
  const isMarkup = discountPercentage > 0;

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mb-4 shadow-sm">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-2xl">🏨</span>
            <div>
              <h4 className="font-semibold text-blue-900 text-base">
                Strategia weekendowa wykryta!
              </h4>
              <p className="text-sm text-blue-700 mt-1">
                {strategy.explanation}
              </p>
            </div>
          </div>

          {strategy.pricingSuggestion && (
            <div className="bg-white rounded-lg p-3 mt-3 border border-blue-100">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-gray-600">Średnia cena bazowa:</span>
                  <div className="font-semibold text-gray-900">
                    {Math.round(strategy.pricingSuggestion.avgOriginalPrice)} zł
                  </div>
                </div>
                <div>
                  <span className="text-gray-600">Sugerowana cena:</span>
                  <div className="font-semibold text-lg text-blue-700">
                    {Math.round(strategy.pricingSuggestion.suggestedPrice)} zł
                  </div>
                </div>
              </div>

              <div className="mt-2 text-center">
                <span
                  className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                    isMarkup
                      ? "bg-green-100 text-green-800"
                      : isDiscount
                        ? "bg-red-100 text-red-800"
                        : "bg-gray-100 text-gray-800"
                  }`}
                >
                  {isMarkup ? "+" : ""}
                  {discountPercentage}%{" "}
                  {isMarkup ? "narzut" : isDiscount ? "rabat" : "bez zmiany"}
                </span>
              </div>
            </div>
          )}

          <div className="text-xs text-blue-600 mt-2 flex items-center gap-2">
            <span>💡</span>
            <span>
              Ceny zostały pobrane z Profitroom • Narzut zostanie zastosowany
              globalnie
            </span>
          </div>
        </div>

        <div className="flex gap-2 ml-4">
          <button
            onClick={onApply}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
          >
            Zastosuj
          </button>
          <button
            onClick={onDismiss}
            className="px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-300 transition-colors"
          >
            Pomiń
          </button>
        </div>
      </div>
    </div>
  );
};

export default WeekendStrategyBanner;
